import {createAction, createReducer} from 'redux-act';
import {fullResetFields} from '../prescriptionValues/prescriptionValues';

export const PRESCRIPTION = 'prescription';
export const COUNTING = 'counting';

export type StepType = typeof PRESCRIPTION | typeof COUNTING;

export const initialState: StepType = PRESCRIPTION;

/**
 * List of actions
 */
export const changeStep = createAction<StepType>('CONTACTS_WIZARD_SET_STEP');

/**
 * Step reducer
 */
export const wizardStep = createReducer<StepType>({}, initialState)
    /**
     * Subscribe actions
     * https://www.npmjs.com/package/redux-act#typescript
     */
    .on(changeStep, (state: StepType, payload: StepType): StepType => payload)
    .on(fullResetFields, () => initialState);
